/**
 * Реестр feature-api-слайсов (RTK Query) EyeHub.
 *
 * ─────────────────────────────────────────────────────────────────────────
 * КАК FEATURE-СТРАНИЦА РЕГИСТРИРУЕТ СВОЙ API (одно место, одна строка):
 *
 *   1. Создать слайс, напр. в каталоге redux/api/<feature>/<feature>Api.js:
 *        createApi({ reducerPath: "<feature>Api", baseQuery: axiosBaseQuery(), ... })
 *
 *   2. Импортировать его здесь (обычный ESM-import с относительным путём до
 *      созданного файла) и добавить в массив featureApis ниже:
 *        const featureApis = [organizationsApi, licensesApi];
 * ─────────────────────────────────────────────────────────────────────────
 *
 * reducers.js автоматически подключит api.reducer по api.reducerPath,
 * store/index.js — api.middleware. Ничего больше править не нужно.
 */

import { organizationsApi } from "./redux/api/organizations/organizationsApi";
import { connectorsApi } from "./redux/api/connectors/connectorsApi";
import { enrollmentApi } from "./redux/api/enrollment/enrollmentApi";
import { licensesApi } from "./redux/api/licenses/licensesApi";
import { federationApi } from "./redux/api/federation/federationApi";
import { supportApi } from "./redux/api/support/supportApi";
import { dashboardApi } from "./redux/api/dashboard/dashboardApi";
import { discoveryApi } from "./redux/api/discovery/discoveryApi";
import { maintenanceApi } from "./redux/api/maintenance/maintenanceApi";
// Срез 3 (самообслуживание): операторский провижининг (hub-admin) и переключатель
// перерасхода (org-admin). Плоскости разделены на два слайса намеренно — так же,
// как разделены их бэкенд-ресурсы `admin/` и `self-service/`.
import { provisioningApi } from "./redux/api/provisioning/provisioningApi";
import { selfServiceApi } from "./redux/api/selfService/selfServiceApi";
import { findclinicApi } from "./redux/api/findclinic/findclinicApi";

const featureApis = [
  organizationsApi,
  connectorsApi,
  enrollmentApi,
  licensesApi,
  federationApi,
  supportApi,
  dashboardApi,
  discoveryApi,
  maintenanceApi,
  provisioningApi,
  selfServiceApi,
  findclinicApi,
];

export default featureApis;
